import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of, shareReplay, tap } from 'rxjs';
import { environment } from 'src/environments/environment';
import { HomeData } from '../interfaces/home-data.interface';
import { NavBar } from 'src/app/source/shared/components/nav-bar/nav-bar.interface';

@Injectable({
  providedIn: 'root'
})
export class HomeService {
  public baseUrl = environment.uiService.url;

  private homeDataCache: HomeData | null = null;

  constructor(public httpClient: HttpClient) { }

  getHomeData(): Observable<HomeData> {
    if (this.homeDataCache) {
      return of(this.homeDataCache);
    }

    return this.httpClient.get<HomeData>(this.baseUrl + '/home').pipe(
      tap((data) => this.homeDataCache = data)
    );
  }

  getCachedHomeData(): HomeData | null {
    return this.homeDataCache;
  }

  updateHomeDataCache(data: HomeData): void {
    this.homeDataCache = data;
  }

  // getNavbarData(): Observable<NavBar> {
  //   return this.httpClient.get<NavBar>(this.baseUrl + '/menu');
  // }


  private navbarData$: Observable<NavBar> | null = null;

  getNavbarData(): Observable<NavBar> {
    if (!this.navbarData$) {
      this.navbarData$ = this.httpClient.get<NavBar>(this.baseUrl + '/menu').pipe(
        shareReplay(1) // <-- esto comparte la última respuesta a múltiples subscriptores
      );
    }

    return this.navbarData$;
  }

}
